#content
<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100 p-relative">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" @doLoad="doLoad" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-8" v-if="isLoaded">
				<chart-view ref="ChartView" @Refresh="refresh" :scrId="scrId"></chart-view>
			</div>
			<div class="sf-col sf-col-12 d-flex w-100" style="justify-content: space-between">
				<sf-card class="p-0 border-0 bg-transparent h-100 pprRptGrp" style="width: 50%">
					<table-left ref="tableLeftView" @Refresh="refresh" :scrId="scrId"></table-left>
				</sf-card>
				<sf-card class="p-0 border-0 bg-transparent h-100 m-0" style="width: 49%">
					<table-right ref="tableRightView" @Refresh="refresh" :scrId="scrId" @OpenPopup="openPopup"></table-right>
				</sf-card>
			</div>
		</div>
		<!-- 불량보고서 등록/수정 팝업 -->
		<popup-detail ref="popupRef" @Refresh="refresh" :scrId="scrId"></popup-detail>
	</div>
</template>

<script>
import SearchView from './Search/Search';
import TableLeft from './Table/TableLeft';
import TableRight from './Table/TableRight';
import ChartView from './Table/Chart.vue';
import PopupDetail from '@pqy/pcku/PrtRpt/Content/Popup/Popup'; //불량보고서 등록/수정 팝업

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false
		};
	},
	components: { SearchView, TableLeft, TableRight, ChartView, PopupDetail },
	methods: {
		refresh() {
			this.$refs.searchView.searchList();
		},
		doLoad() {
			this.isLoaded = true;
		},
		openPopup(params) {
			this.$refs.popupRef.open(params, 'OS');
		}
	}
};
</script>
